module.exports = __webpack_public_path__ + "img/compose-a-led-lighting-system.c799756b.png";